<template>
  <div class="vm-conversation">
    <div v-if="!inVideoRoom" class="vm-videochat-side">
      <div class="vm-side-header">
        <div class="vm-videochat-search-wrap">
          <input
            placeholder="Поиск..."
            v-model="searchControl"
            class="vm-videochat-search"
            type="text"
          />
        </div>
        <button @click="openAddPersonDialog" class="vm-exit-button" v-b-tooltip.hover title="пригласить в комнату">	
          <i class="material-icons">person_add</i>	
        </button>
        <button @click="openRecords" class="vm-exit-button" v-b-tooltip.hover title="видеозаписи">	
          <i class="material-icons">movie</i>	
        </button>
      </div>
      <div class="vm-side-subheader">
        Пользователи
      </div>
      <div class="vm-contacts">
        <div v-if="!loading">
          <Contact
            v-for="(contact, index) in contacts"
            :key="index"
            :contact="contact" @drop-user="dropUser"
          />
        </div>
        <div v-else>
          <LoadingContactList />
        </div>
      </div>
    </div>
    <div v-else class="vm-videochat-side vm-video-side">
      <VideoSide
        v-if="frames.length"
        :frames="frames"
        :activeFrame="mainFrame"
        @open="openAddPersonDialog"
        @drop-user="dropUser"
      />
    </div>
    <div class="vm-videochat-content-wrap">
      <div key="save" class="vm-videochat-content">
        <div class="vm-videochat-header">
          <div class="vm-videochat-header-wrapper">
            <div class="vm-videochat-info">
              <div class="vm-videochat-title">{{ name }}</div>
              <div class="vm-videochat-subtitle">{{ contacts.length }} участников, {{ onlineCount }} онлайн</div>
            </div>
            <div v-if="callIsActive" class="vm-videochat-header-active-call">
              <span>{{ callCount }} в разговоре</span>
              <button @click="toggleCall" type="button">
                <i class="material-icons">add_ic_call</i>
              </button>
            </div>    
            <div v-else class="vm-videochat-header-action">
              <button v-if="inVideoRoom" :disabled="!available()" @click="toggleRec" type="button" style="margin-right:5px; width:70px;border-radius:25px"  v-b-tooltip.hover :title="$store.state.chat.isRec ? 'идет запись': 'начать запись'">
                <i :style="{ color: $store.state.chat.isRec ? 'red' : 'white' }" class="material-icons">fiber_manual_record</i> Rec
              </button>
              <button @click="toggleCall" type="button" :class="{ red: inVideoRoom }" v-b-tooltip.hover :title="inVideoRoom ? 'выйти из видеоконференцию': 'войти в видеоконференции'">
                <i class="material-icons">phone</i>
              </button>
            </div>
          </div>
        </div>
        <ChatView :messages="messages" />
        <div class="vm-videochat-footer">
          <div class="vm-videochat-action">
            <label class="vm-attach-button" v-b-tooltip.hover title="прикрепить файл">
              <input
                type="file"
                @change="selectFiles"
                id="attach-files"
                class="upload-button"
                multiple
              />
              <i class="material-icons">attach_file</i>
            </label>
          </div>
          <div class="vm-videochat-enterarea">
            <label for="enter"></label>
            <div class="vm-textarea-wrap">
              <ResizeAuto>
                <textarea
                  id="enter"
                  placeholder="Введите сообщение..."
                  class="textarea"
                  rows="1"
                  @keydown.enter.exact.prevent="sendMessage"
                ></textarea>
              </ResizeAuto>
            </div>
          </div>
          <div class="vm-videochat-action"></div>
          <div class="vm-videochat-action"></div>
        </div>
      </div>
      <transition name="slide" :duration="400">
        <Invite v-if="contentPage === 'invite'"
          class="vm-videochat-content vm-videochat-invite"
          @close="backToChat"
          @invite="openResult"
        />
      </transition>
      <transition name="slide" :duration="400">
        <InviteResult v-if="contentPage === 'invite-result'"
          class="vm-videochat-content vm-videochat-invite-result"
          :users="inviteResult"
          @close="backToChat"
        />
      </transition>
      <transition name="slide" :duration="400">
        <Records v-if="contentPage === 'records'"
          class="vm-videochat-content vm-videochat-invite-result"
          @close="backToChat"
        />
      </transition>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import ResizeAuto from './ResizeAuto';
import Contact from './Contact';
import VideoSide from './VideoSide';
import moment from 'moment';
import { delay } from 'lodash';
import { chatApi } from '@app/services';
import ChatView from './ChatView';
import 'moment/locale/ru';
import { iconName } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import LoadingContactList from './LoadingContactList';
import Invite from './invite/index';
import InviteResult from './invite-result/index';
import Records from './records/index';
import toastr from 'toastr';

moment.locale('ru');

export default {
  components: {
    ResizeAuto, Contact, VideoSide, ChatView, LoadingContactList, Invite, InviteResult, Records
  },
  data: () => ({
    inviteResult: [],
    contentPage: 'chat', // 'chat' | 'invite' | 'invite-result'
    searchControl: null,
    searchRoomControl: null,
    conversationNameControl: null,
    inVideoRoom: false,
    activeFrame: null,
    stream: null,
    count: {
      tota: 0,
      count: 0
    },
    message: '',
    loaders: {
      conversation: false,
      history: false
    },
    user: null,
    pagination: {
      limit: 3,
      offset: 0
    }
  }),
  async beforeRouteUpdate(to, from, next) {
    this.inVideoRoom = false;
    const conversationId = to.params.id;
    if (this.$store.state.chat.session) {
      await this.$store.dispatch('chat/disconnect');
    }
    await this.$store.dispatch('chat/joinConversation', conversationId);
    next();
  },
  async created() {
    const conversationId = this.$route.params.id;
    this.$store.dispatch('chat/joinConversation', conversationId);
    this.contentPage = this.$store.state.chat.contentPage;
  },
  methods: {
    toggleRec() {
      if (!this.$store.state.chat.isRec) {
        chatApi.startRecord(this.$route.params.id).then(res => {
            this.$store.commit('chat/setIsRec', true);
            toastr.info('Запись началась');
        }).catch(error => {
          toastr.error('Ошибка');
        });
      } else {
        chatApi.stopRecord(this.$route.params.id).then(res => {
          this.$store.commit('chat/setIsRec', false);
          toastr.info('Запись остановлена');
        }).catch(error => {
          toastr.error('Ошибка');
        });
      }
    },
    available() {
      let isAvail = false;
      if (this.$store.state.permission.resources.organization) {
        Object.keys(this.$store.state.permission.resources.organization).forEach(obj => {
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('doctor');
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('employee');
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('orgadmin');
        });
      }
      return isAvail;
    },
    async dropUser(evt) {
      chatApi.exitConversation(this.$store.state.chat.session.sessionId, evt.id).then(async res => {
      if (this.searchControl) {
        this.searchControl = '';
        this.$store.dispatch('chat/joinConversation', this.$store.state.chat.session.sessionId);
      } else if (this.$store.state.auth.user.id === evt.id) {
        this.$router.push({ name: 'vuexchat'});
      } else { 
        const newcontacts = this.contacts.filter(obj => {
          if (obj.id !== evt.id) {
            return obj;
          }
        });
        this.$store.commit('chat/setContacts', newcontacts);
      }
     }).catch(error => { toastr.error('Ошибка');});
    },
    openResult(users) {
      this.inviteResult = users;
      this.$store.commit('chat/setContentPage', 'invite-result');
    },
    openAddPersonDialog() {
      this.$store.commit('chat/setContentPage', 'invite');
    },
    openRecords() {
      this.$store.commit('chat/setContentPage', 'records');
    },
    backToChat() {
      this.$store.commit('chat/setContentPage', 'chat');
    },
    download(url) {
      document.location.href = url;
    },
    async toggleCall() {
      if (this.inVideoRoom) {
        await this.$store.dispatch('chat/stopStreaming');
        const me = this.$store.state.chat.contacts.find(c => c.id === this.$store.state.auth.user.id);
        me.isStream = false;
      } else {
        chatApi.viewsRecordings(this.$route.params.id).then(res => {
          this.$store.commit('chat/setIsRec', res.now_recording);
        }).catch(error => {
          toastr.error('Ошибка');
        });
        await this.$store.dispatch('chat/startStreaming');
        const me = this.$store.state.chat.contacts.find(c => c.id === this.$store.state.auth.user.id);
        me.isStream = true;
      }
      this.inVideoRoom = !this.inVideoRoom;
    },
    async selectFiles({ target }) {
      const { firstName, lastName, userId } = this.$store.state.permission;
      const user = {
        user: `${firstName} ${lastName}`,
        userId
      };
      const conversationId = this.$route.params.id;
      const files = [];
      for (var i = 0; i < target.files.length; i++) {
        const targetFile = target.files.item(i);
        if (targetFile.type.substring(0, 5) === 'image') {
          const data = await this.readFile(targetFile);
          files.push({
            targetFile,
            source: 'base64',
            type: 'image',
            data
          });
        } else {
          files.push({
            targetFile,
            source: 'base64',
            type: 'file',
            name: targetFile.name
          });
        }
      }
      await this.$store.dispatch('chat/sendFiles', { conversationId, user, files });
    },
    async readFile(file) {
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = ({ target }) => resolve(target.result);
        reader.readAsDataURL(file);
      });
    },
    async sendMessage({ target }) {
      const conversationId = this.$route.params.id;
      const text = target.value;
      if (target.value === '' || /^\s*$/i.test(target.value)) {
        target.value = '';
        target.style.height = '27px';
        return;
      }
      target.value = '';
      target.style.height = '27px';
      const { firstName, lastName, userId } = this.$store.state.permission;
      const user = {
        user: `${firstName} ${lastName}`,
        userId
      };
      this.$store.dispatch('chat/sendText', { conversationId, user, text });
    }
  },
  watch: {
    '$store.state.chat.contentPage': function(val) {
      this.contentPage = val;
    }
  },
  computed: {
    callCount() {
      return this.$store.state.chat.frames.length;
    },
    callIsActive() {
      return !this.inVideoRoom &&
        (this.$store.state.chat.frames.length > 0 || this.$store.state.chat.userFrame !== null);
    },
    loading() {
      return this.$store.state.chat.loading;
    },
    name() {
      return this.$store.state.chat.name;
    },
    mainFrame() {
      return this.$store.state.chat.mainFrame;
    },
    frames() {
      return this.$store.getters['chat/frames'];
    },
    onlineCount() {
      return this.$store.getters['chat/onlineCountactCount'];
    },
    messages() {
      return this.$store.getters['chat/messages'];
    },
    contacts() {
      return this.searchControl ?
        this.$store.getters['chat/contacts'].filter(contact => {
          const { first, last } = contact.name;
          return (first + last).indexOf(this.searchControl) > -1;
        }) :
        this.$store.getters['chat/contacts'];
    }
  }
};
</script>

<style scoped>
.vm-side-subheader {
  background-color: rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(255,255,255,.3);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 12px;
  text-transform: uppercase;
}
.vm-exit-button {
  border: 0;
  background-color: transparent;
  color: #fff;
  outline: 0;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 46px;
}
.vm-exit-button i {
  font-size: 32px;
}
.chat-page {
  height: calc(100vh - 64px);
  background-color: white;
}
.vm-videochat {
  max-width: 1248px;
  padding: 24px;
  margin: auto;
  height: 100%;
}
.vm-videochat-title {
  text-transform: uppercase;
  font-size: 18px;
  color: RGB(53, 40, 77);
  font-weight: 500;
}
.vm-videochat-wrapper {
  display: flex;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.vm-conversation {
  display: flex;
  flex: auto;
  height: 100%;
}
.vm-conversation-side {
  position: relative;
  background: linear-gradient(to bottom, #8c30da, #5c48d4);
  box-shadow: inset -30px 0 40px 0 rgba(0,0,0,.15);
  border-radius: 4px 0 0 4px;
  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vm-conversation-side .vm-side-content {
  position: relative;
  flex: auto;
  overflow: hidden;
  height: 100%;
}
.vm-conversation-side .vm-menu {
  position: absolute;
  background-color: #fff;
  border-radius: 4px;
  right: 12px;
  top: 64px;
}
.vm-conversation-side .vm-side-footer form {
  display: flex;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-videochat-search-wrap {
  padding: 12px 0 12px 12px;
  width: 100%;
}
.vm-conversation-side .vm-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-conversation-side .vm-item-link {
  display: flex;
  align-items: center;
  width: 100%;
  color: #fff;
  padding: 12px;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
}
.vm-conversation-side .vm-item-link i {
  margin-right: 12px;
}
.vm-conversation-side .vm-item-link.router-link-active {
  background: linear-gradient(to left, #5d86ed57, #c742d365);
}
.vm-videochat-side {
  max-height: 100%;
  flex: 0 0 250px;
  width: 250px;
  background: linear-gradient(to bottom, #8c30da, #5c48d4);
  z-index: 1;
  display: flex;
  flex-direction: column;
  flex: 0 0 250px;
  width: 250px;
  justify-content: space-between;
}
.vm-side-header {
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-videochat-search {
  display: block;
  border: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 100%;
  color: #fff;
  padding-left: 24px;
  height: 36px;
  outline: none;
}
.vm-videochat-search::placeholder {
  color: #fff;
  font-weight: 300;
}
.vm-contacts {
  overflow-y: auto;
  flex: auto;
}
.vm-videochat-content-wrap {
  position: relative;
  flex: auto;
  border-radius: 0 4px 4px 0;
  overflow: hidden;
}
.vm-videochat-content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(to right, rgb(242, 232, 251), rgb(234, 239, 250));
}
.vm-videochat-invite-result,
.vm-videochat-invite {
  left: 0;
  opacity: 1;
  transition: all 250ms ease;
  z-index: 10;
}
.vm-videochat-invite-result {
  z-index: 11;
}
.vm-videochat-invite.slide-enter-active,
.vm-videochat-invite.slide-leave-active,
.vm-videochat-invite-result.slide-enter-active,
.vm-videochat-invite-result.slide-leave-active {
  opacity: 0;
  left: 100%;
}
.vm-videochat-header {
  height: 60px;
  flex: 0 0 60px;
  border-radius: 0 4px 0 0;
  padding: 0 24px;
}
.vm-videochat-header-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.vm-videochat-header-action {
  margin-left: auto;
  display:flex;
}
.vm-videochat-header-active-call {
  margin-left: auto;
  display: flex;
  align-items: center;
  background-color: rgb(199, 231, 200, 50%);
  padding: 5px;
  border-radius: 23px;
}
.vm-videochat-header-active-call button {
  background-color: rgb(126, 198, 98);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  outline: 0;
}
.vm-videochat-header-active-call span {
  margin: 0 10px;
  color: #424242;
}
.vm-videochat-header-action button {
  border: 0;
  outline: 0;
  background-color: #5c48d4;
  display: flex;
  color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
}
.vm-videochat-view {
  height: calc(100% - 120px);
  /*
  overflow-y: auto;
  padding: 24px;
  */
}
.vm-videochat-footer {
  min-height: 60px;
  background-color: white;
  border-radius: 0 0 4px 0;
  display: flex;
  flex-shrink: 0;
}
.vm-videochat-footer .vm-videochat-action {
  width: 60px;
  display: flex;
  align-items: flex-end;
}
.vm-videochat-enterarea {
  flex: auto;
  position: relative;
}
.vm-videochat-enterarea label {
  position: absolute;
  z-index: 1;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vm-textarea-wrap {
  display: flex;
  align-items: center;
  height: 100%;
}
.vm-videochat-footer textarea {
  position: relative;
  z-index: 2;
  display: block;
  background-color: transparent;
  border: 0;
  width: 100%;
  outline: none;
  resize: none;
}
.vm-videochat-action label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border: 0;
  background-color: transparent;
  transform: rotate(45deg);
  color: RGB(190, 190, 190);
  margin: 0;
  padding: 0;
  cursor: pointer;
}
.vm-videochat-action input {
  display: none;
}
.vm-videochat-action button i {
  font-size: 36px;
}
.vm-videochat-action label:hover i {
  color: rgb(122, 52, 213);
}
/* virtual scroller */
.vm-scroller {
  height: 100%;
  padding: 24px;
  display: flex;
}
.vm-scroller >>> .vue-recycle-scroller__item-wrapper {
  margin-top: auto;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.vm-videochat-side.vm-video-side {
  width: 700px;
  height: 100%;
}
.vm-videochat-header-action button {
  transition: all 300ms ease;
}
.vm-videochat-header-action button.red {
  background-color: red;
  transform: rotate(90deg);
}
@media (max-width: 1280px) {
  .vm-videochat-header {
    height: 48px;
    flex: 0 0 48px;
  }
  .vm-videochat-title {
    font-size: 14px;
  }
  .vm-videochat-subtitle {
    font-size: 12px;
  }
  .vm-videochat-header button {
    width: 32px;
    height: 32px;
  }
  .vm-videochat-header button i {
    font-size: 18px;
  }
  .vm-side-header {
    height: 48px;
  }
  .vm-videochat-side {
    width: 240px;
  }
  .vm-videochat-search {
    padding: 0 12px;
    height: 32px;
    font-size: 14px;
  }
  .vm-exit-button {
    height: 32px;
    flex: 0 0 32px;
  }
  .vm-exit-button i {
    font-size: 32px;
  }
  .vm-videochat-footer {
    min-height: 48px;
  }
  .vm-videochat-footer .vm-videochat-action {
    width: 48px;
  }
  .vm-videochat-action label {
    width: 48px;
    height: 48px;
  }
  .vm-videochat-footer textarea {
    font-size: 14px;
  }
}


</style>
